import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-inspect",
  "use": "menu-inspect-usage",
  "viewBox": "0 0 23.03 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23.03 28\" id=\"menu-inspect\"><title>资源 15</title><g data-name=\"图层 2\"><path d=\"M23 4.06h-1.13a16.22 16.22 0 0 1-5.21-1.14A24.32 24.32 0 0 1 12.19.5L11.5 0l-.68.5a22.42 22.42 0 0 1-4.46 2.4A16.29 16.29 0 0 1 1.15 4H0v11.84C0 21.75 7.49 28 11.52 28S23 21.75 23 15.84zm-8.47 11.45H13v2.26a1.51 1.51 0 0 1-3 0v-2.26H8.5a1.51 1.51 0 0 1 0-3H10v-2.28a1.51 1.51 0 1 1 3 0v2.26h1.51a1.51 1.51 0 1 1 0 3z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-inspect.svg
// module id = 2Idb
// module chunks = 6